import React from 'react';
import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styled from 'styled-components';
import upper1Image1 from './images/upper1_1.jpg';
import upper2Image1 from './images/upper2_1.jpg';
import upper3Image1 from './images/upper3_1.jpg';
import upper4Image1 from './images/upper4_1.jpg';
import upper1Image2 from './images/upper1_2.jpg';
import upper2Image2 from './images/upper2_2.jpg';
import upper3Image2 from './images/upper3_2.jpg';
import upper4Image2 from './images/upper4_2.jpg';
import upper1Image3 from './images/upper1_3.jpg';
import upper2Image3 from './images/upper2_3.jpg';
import upper3Image3 from './images/upper3_3.jpg';
import upper4Image3 from './images/upper4_3.jpg';
import lower1Image1 from './images/lower1_1.jpg';
import lower2Image1 from './images/lower2_1.jpg';
import lower3Image1 from './images/lower3_1.jpg';
import lower4Image1 from './images/lower4_1.jpg';
import lower1Image2 from './images/lower1_2.jpg';
import lower2Image2 from './images/lower2_2.jpg';
import lower3Image2 from './images/lower3_2.jpg';
import lower4Image2 from './images/lower4_2.jpg';
import lower1Image3 from './images/lower1_3.jpg';
import lower2Image3 from './images/lower2_3.jpg';
import lower3Image3 from './images/lower3_3.jpg';
import lower4Image3 from './images/lower4_3.jpg';

const carouselProps = {
  showArrows: false,
  showStatus: false,
  showIndicators: false,
  showThumbs: false,
  autoPlay: true,
  infiniteLoop: true,
  stopOnHover: false,
  swipeable: false,
  axis: 'vertical',
};

const CarouselStyles = styled.section`
  height: 110vh;

  .carousel-upper,
  .carousel-lower {
    img {
      height: 55vh;
      object-fit: cover;
    }
  }

  .carousel-upper {
    img {
      object-position: bottom;
    }
  }

  .carousel-lower {
    img {
      object-position: top;
    }
  }
`;

export default function Carousel() {
  return (
    <CarouselStyles>
      <ResponsiveCarousel
        className="carousel-upper"
        interval="2000"
        {...carouselProps}
      >
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${upper1Image1} 768w,
            ${upper1Image2} 1700w,
            ${upper1Image3} 2560w
            `}
          src={upper1Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${upper2Image1} 768w,
            ${upper2Image2} 1700w,
            ${upper2Image3} 2560w
            `}
          src={upper2Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${upper3Image1} 768w,
            ${upper3Image2} 1700w,
            ${upper3Image3} 2560w
            `}
          src={upper3Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${upper4Image1} 768w,
            ${upper4Image2} 1700w,
            ${upper4Image3} 2560w
            `}
          src={upper4Image3}
          alt="a mouse"
        />
      </ResponsiveCarousel>
      <ResponsiveCarousel
        className="carousel-lower"
        interval="2500"
        {...carouselProps}
      >
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${lower1Image1} 768w,
            ${lower1Image2} 1700w,
            ${lower1Image3} 2560w
            `}
          src={lower1Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${lower2Image1} 768w,
            ${lower2Image2} 1700w,
            ${lower2Image3} 2560w
            `}
          src={lower2Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${lower3Image1} 768w,
            ${lower3Image2} 1700w,
            ${lower3Image3} 2560w
            `}
          src={lower3Image3}
          alt="a mouse"
        />
        <img
          sizes="(max-width: 2560px) 100vw, 2560px"
          srcSet={`
            ${lower4Image1} 768w,
            ${lower4Image2} 1700w,
            ${lower4Image3} 2560w
            `}
          src={lower4Image3}
          alt="a mouse"
        />
      </ResponsiveCarousel>
    </CarouselStyles>
  );
}
